import {
  ButtonBorderStyle,
  ButtonShapeStyle,
  CustomizationFormProperties,
  HeaderPosition,
  BackgroundTypeStyle,
  BackgroundType,
  ButtonShadowStyle,
  ColorOpacity,
} from '@web-apps/utils-types'

import { PreviewThemeType } from '../../types'
import { Color } from '@web-apps/utils-shared'

const STATIC_GRADIENT_THEMES: PreviewThemeType[] = [
  {
    [CustomizationFormProperties.HEADER_POSITION]: HeaderPosition.CENTER,
    [CustomizationFormProperties.BUTTONS_SHAPE]: ButtonShapeStyle.ROUNDED,
    [CustomizationFormProperties.BUTTONS_BORDER_STYLE]:
      ButtonBorderStyle.OUTLINE,
    [CustomizationFormProperties.BUTTONS_SHADOW_OPACITY]: ColorOpacity['60%'],
    [CustomizationFormProperties.BACKGROUND]: '#DF90B3',
    [CustomizationFormProperties.BACKGROUND_TYPE_STYLE]:
      BackgroundTypeStyle.REGULAR,
    [CustomizationFormProperties.BACKGROUND_TYPE]: BackgroundType.Gradient,
    [CustomizationFormProperties.TEXT]: '#FFFFFF',
    [CustomizationFormProperties.BUTTONS_BACKGROUND_COLOR]: '#FFFFFF',
    [CustomizationFormProperties.BUTTONS_BORDER_COLOR]: '#FFFFFF',
    [CustomizationFormProperties.BUTTONS_TEXT_COLOR]: '#FFFFFF',
    [CustomizationFormProperties.BACKGROUND_GRADIENT_COLORS]: [
      '#DF90B3',
      '#a9bee4',
    ],
    themeName: 'gradient_predefined_purple',
  },
  {
    [CustomizationFormProperties.HEADER_POSITION]: HeaderPosition.CENTER,
    [CustomizationFormProperties.BUTTONS_SHAPE]: ButtonShapeStyle.ROUNDED,
    [CustomizationFormProperties.BUTTONS_BORDER_STYLE]:
      ButtonBorderStyle.FILLED,
    [CustomizationFormProperties.BUTTONS_BACKGROUND_OPACITY]:
      ColorOpacity['100%'],
    [CustomizationFormProperties.BACKGROUND]: '#ED1C24',
    [CustomizationFormProperties.BACKGROUND_TYPE_STYLE]:
      BackgroundTypeStyle.REGULAR,
    [CustomizationFormProperties.BACKGROUND_TYPE]: BackgroundType.Gradient,
    [CustomizationFormProperties.TEXT]: '#FFFFFF',
    [CustomizationFormProperties.BUTTONS_BACKGROUND_COLOR]: '#111111',
    [CustomizationFormProperties.BUTTONS_BORDER_COLOR]: '#FFFFFF',
    [CustomizationFormProperties.BUTTONS_TEXT_COLOR]: '#FFFFFF',
    [CustomizationFormProperties.BACKGROUND_GRADIENT_COLORS]: [
      '#ED1C24',
      '#000000',
    ],
    themeName: 'gradient_predefined_red',
  },
  {
    [CustomizationFormProperties.HEADER_POSITION]: HeaderPosition.CENTER,
    [CustomizationFormProperties.BUTTONS_SHAPE]: ButtonShapeStyle.PILL,
    [CustomizationFormProperties.BUTTONS_BORDER_STYLE]:
      ButtonBorderStyle.FILLED,
    [CustomizationFormProperties.BUTTONS_BACKGROUND_OPACITY]:
      ColorOpacity['100%'],
    [CustomizationFormProperties.BACKGROUND]: '#1D9ADF',
    [CustomizationFormProperties.BACKGROUND_TYPE_STYLE]:
      BackgroundTypeStyle.REGULAR,
    [CustomizationFormProperties.BACKGROUND_TYPE]: BackgroundType.Gradient,
    [CustomizationFormProperties.TEXT]: '#111111',
    [CustomizationFormProperties.BUTTONS_BACKGROUND_COLOR]: '#FFFFFF',
    [CustomizationFormProperties.BUTTONS_BORDER_COLOR]: '#FFFFFF',
    [CustomizationFormProperties.BUTTONS_TEXT_COLOR]: '#111111',
    [CustomizationFormProperties.BACKGROUND_GRADIENT_COLORS]: [
      '#1D9ADF',
      '#8AF5CD',
    ],
    themeName: 'gradient_predefined_turquoise',
  },
  {
    [CustomizationFormProperties.HEADER_POSITION]: HeaderPosition.CENTER,
    [CustomizationFormProperties.BUTTONS_SHAPE]: ButtonShapeStyle.ROUNDED,
    [CustomizationFormProperties.BUTTONS_BORDER_STYLE]:
      ButtonBorderStyle.FILLED,
    [CustomizationFormProperties.BUTTONS_BACKGROUND_OPACITY]:
      ColorOpacity['100%'],
    [CustomizationFormProperties.BACKGROUND]: '#F5A5B5',
    [CustomizationFormProperties.BACKGROUND_TYPE_STYLE]:
      BackgroundTypeStyle.REGULAR,
    [CustomizationFormProperties.BACKGROUND_TYPE]: BackgroundType.Gradient,
    [CustomizationFormProperties.TEXT]: '#FFFFFF',
    [CustomizationFormProperties.BUTTONS_BACKGROUND_COLOR]: '#FFFFFF',
    [CustomizationFormProperties.BUTTONS_BORDER_COLOR]: '#FFFFFF',
    [CustomizationFormProperties.BUTTONS_TEXT_COLOR]: '#111111',
    [CustomizationFormProperties.BACKGROUND_GRADIENT_COLORS]: [
      '#F5A5B5',
      '#FDD5CD',
    ],
    themeName: 'gradient_predefined_pink',
  },
  {
    [CustomizationFormProperties.HEADER_POSITION]: HeaderPosition.CENTER,
    [CustomizationFormProperties.BUTTONS_SHAPE]: ButtonShapeStyle.SQUARE,
    [CustomizationFormProperties.BUTTONS_BORDER_STYLE]:
      ButtonBorderStyle.FILLED,
    [CustomizationFormProperties.BUTTONS_BACKGROUND_OPACITY]:
      ColorOpacity['100%'],
    [CustomizationFormProperties.BACKGROUND]: '#B56E51',
    [CustomizationFormProperties.BACKGROUND_TYPE_STYLE]:
      BackgroundTypeStyle.REGULAR,
    [CustomizationFormProperties.BACKGROUND_TYPE]: BackgroundType.Gradient,
    [CustomizationFormProperties.TEXT]: '#FFFFFF',
    [CustomizationFormProperties.BUTTONS_BACKGROUND_COLOR]: '#111111',
    [CustomizationFormProperties.BUTTONS_BORDER_COLOR]: '#111111',
    [CustomizationFormProperties.BUTTONS_TEXT_COLOR]: '#FFFFFF',
    [CustomizationFormProperties.BACKGROUND_GRADIENT_COLORS]: [
      '#B56E51',
      '#D5BFA7',
    ],
    themeName: 'gradient_predefined_coral',
  },
]

export const getThemes = (colors: Color[]): PreviewThemeType[] => {
  const customColorsThemes =
    colors?.length === 3
      ? [
          {
            [CustomizationFormProperties.HEADER_POSITION]:
              HeaderPosition.CENTER,
            [CustomizationFormProperties.BUTTONS_SHAPE]:
              ButtonShapeStyle.ROUNDED,
            [CustomizationFormProperties.BUTTONS_BORDER_STYLE]:
              ButtonBorderStyle.FILLED,
            [CustomizationFormProperties.BUTTONS_BACKGROUND_OPACITY]:
              ColorOpacity['100%'],
            [CustomizationFormProperties.BACKGROUND]: colors[0].hexValue,
            [CustomizationFormProperties.BACKGROUND_TYPE_STYLE]:
              BackgroundTypeStyle.REGULAR,
            [CustomizationFormProperties.BACKGROUND_TYPE]: BackgroundType.Solid,
            [CustomizationFormProperties.TEXT]: colors[1].hexValue,
            [CustomizationFormProperties.BUTTONS_BACKGROUND_COLOR]:
              colors[2].hexValue,
            [CustomizationFormProperties.BUTTONS_SHADOW]:
              ButtonShadowStyle.NO_SHADOW,
            [CustomizationFormProperties.BUTTONS_SHADOW_OPACITY]:
              ColorOpacity['60%'],
            [CustomizationFormProperties.BUTTONS_SHADOW_COLOR]: '#333333',
            [CustomizationFormProperties.BUTTONS_BORDER_COLOR]:
              colors[2].hexValue,
            [CustomizationFormProperties.BUTTONS_TEXT_COLOR]:
              colors[1].hexValue,
            themeName: 'custom_colors_plain_1',
          },
          {
            [CustomizationFormProperties.HEADER_POSITION]:
              HeaderPosition.CENTER,
            [CustomizationFormProperties.BUTTONS_SHAPE]:
              ButtonShapeStyle.ROUNDED,
            [CustomizationFormProperties.BUTTONS_BORDER_STYLE]:
              ButtonBorderStyle.FILLED,
            [CustomizationFormProperties.BUTTONS_BACKGROUND_OPACITY]:
              ColorOpacity['100%'],
            [CustomizationFormProperties.BUTTONS_SHADOW]:
              ButtonShadowStyle.NO_SHADOW,
            [CustomizationFormProperties.BUTTONS_SHADOW_OPACITY]:
              ColorOpacity['60%'],
            [CustomizationFormProperties.BUTTONS_SHADOW_COLOR]: '#333333',
            [CustomizationFormProperties.BACKGROUND]: colors[2].hexValue,
            [CustomizationFormProperties.BACKGROUND_TYPE_STYLE]:
              BackgroundTypeStyle.REGULAR,
            [CustomizationFormProperties.BACKGROUND_TYPE]: BackgroundType.Solid,
            [CustomizationFormProperties.TEXT]: colors[0].hexValue,
            [CustomizationFormProperties.BUTTONS_BACKGROUND_COLOR]:
              colors[1].hexValue,
            [CustomizationFormProperties.BUTTONS_BORDER_COLOR]:
              colors[1].hexValue,
            [CustomizationFormProperties.BUTTONS_TEXT_COLOR]:
              colors[0].hexValue,
            themeName: 'custom_colors_plain_2',
          },
          {
            [CustomizationFormProperties.HEADER_POSITION]:
              HeaderPosition.CENTER,
            [CustomizationFormProperties.BUTTONS_SHAPE]:
              ButtonShapeStyle.ROUNDED,
            [CustomizationFormProperties.BUTTONS_BORDER_STYLE]:
              ButtonBorderStyle.OUTLINE,
            [CustomizationFormProperties.BUTTONS_BACKGROUND_OPACITY]:
              ColorOpacity['100%'],
            [CustomizationFormProperties.BUTTONS_SHADOW]:
              ButtonShadowStyle.NO_SHADOW,
            [CustomizationFormProperties.BUTTONS_SHADOW_OPACITY]:
              ColorOpacity['60%'],
            [CustomizationFormProperties.BUTTONS_SHADOW_COLOR]: '#333333',
            [CustomizationFormProperties.BACKGROUND]: colors[1].hexValue,
            [CustomizationFormProperties.BACKGROUND_TYPE_STYLE]:
              BackgroundTypeStyle.REGULAR,
            [CustomizationFormProperties.BACKGROUND_TYPE]: BackgroundType.Solid,
            [CustomizationFormProperties.TEXT]: colors[0].hexValue,
            [CustomizationFormProperties.BUTTONS_BACKGROUND_COLOR]:
              colors[1].hexValue,
            [CustomizationFormProperties.BUTTONS_BORDER_COLOR]:
              colors[0].hexValue,
            [CustomizationFormProperties.BUTTONS_TEXT_COLOR]:
              colors[0].hexValue,
            themeName: 'custom_colors_plain_3',
          },
          {
            [CustomizationFormProperties.HEADER_POSITION]:
              HeaderPosition.CENTER,
            [CustomizationFormProperties.BUTTONS_SHAPE]:
              ButtonShapeStyle.ROUNDED,
            [CustomizationFormProperties.BUTTONS_BORDER_STYLE]:
              ButtonBorderStyle.FILLED,
            [CustomizationFormProperties.BUTTONS_BACKGROUND_OPACITY]:
              ColorOpacity['100%'],
            [CustomizationFormProperties.BUTTONS_SHADOW]:
              ButtonShadowStyle.NO_SHADOW,
            [CustomizationFormProperties.BUTTONS_SHADOW_OPACITY]:
              ColorOpacity['60%'],
            [CustomizationFormProperties.BUTTONS_SHADOW_COLOR]: '#333333',
            [CustomizationFormProperties.BACKGROUND]: '',
            [CustomizationFormProperties.BACKGROUND_TYPE_STYLE]:
              BackgroundTypeStyle.REGULAR,
            [CustomizationFormProperties.BACKGROUND_TYPE]:
              BackgroundType.Gradient,
            [CustomizationFormProperties.BACKGROUND_GRADIENT_COLORS]: [
              colors[0].hexValue,
              colors[1].hexValue,
            ],
            [CustomizationFormProperties.TEXT]: colors[1].hexValue,
            [CustomizationFormProperties.BUTTONS_BACKGROUND_COLOR]:
              colors[2].hexValue,
            [CustomizationFormProperties.BUTTONS_BORDER_COLOR]: '',
            [CustomizationFormProperties.BUTTONS_TEXT_COLOR]:
              colors[1].hexValue,
            themeName: 'custom_colors_gradient_1',
          },
          {
            [CustomizationFormProperties.HEADER_POSITION]:
              HeaderPosition.CENTER,
            [CustomizationFormProperties.BUTTONS_SHAPE]:
              ButtonShapeStyle.ROUNDED,
            [CustomizationFormProperties.BUTTONS_BORDER_STYLE]:
              ButtonBorderStyle.FILLED,
            [CustomizationFormProperties.BUTTONS_BACKGROUND_OPACITY]:
              ColorOpacity['100%'],
            [CustomizationFormProperties.BUTTONS_SHADOW]:
              ButtonShadowStyle.NO_SHADOW,
            [CustomizationFormProperties.BUTTONS_SHADOW_OPACITY]:
              ColorOpacity['60%'],
            [CustomizationFormProperties.BUTTONS_SHADOW_COLOR]: '#333333',
            [CustomizationFormProperties.BACKGROUND]: '',
            [CustomizationFormProperties.BACKGROUND_TYPE_STYLE]:
              BackgroundTypeStyle.REGULAR,
            [CustomizationFormProperties.BACKGROUND_TYPE]:
              BackgroundType.Gradient,
            [CustomizationFormProperties.BACKGROUND_GRADIENT_COLORS]: [
              colors[2].hexValue,
              colors[0].hexValue,
            ],
            [CustomizationFormProperties.TEXT]: colors[0].hexValue,
            [CustomizationFormProperties.BUTTONS_BACKGROUND_COLOR]:
              colors[1].hexValue,
            [CustomizationFormProperties.BUTTONS_BORDER_COLOR]: '',
            [CustomizationFormProperties.BUTTONS_TEXT_COLOR]:
              colors[0].hexValue,
            themeName: 'custom_colors_gradient_2',
          },
          {
            [CustomizationFormProperties.HEADER_POSITION]:
              HeaderPosition.CENTER,
            [CustomizationFormProperties.BUTTONS_SHAPE]:
              ButtonShapeStyle.ROUNDED,
            [CustomizationFormProperties.BUTTONS_BORDER_STYLE]:
              ButtonBorderStyle.OUTLINE,
            [CustomizationFormProperties.BUTTONS_SHADOW]:
              ButtonShadowStyle.NO_SHADOW,
            [CustomizationFormProperties.BUTTONS_BACKGROUND_OPACITY]:
              ColorOpacity['100%'],
            [CustomizationFormProperties.BUTTONS_SHADOW_OPACITY]:
              ColorOpacity['60%'],
            [CustomizationFormProperties.BUTTONS_SHADOW_COLOR]: '#333333',
            [CustomizationFormProperties.BACKGROUND]: '',
            [CustomizationFormProperties.BACKGROUND_TYPE_STYLE]:
              BackgroundTypeStyle.REGULAR,
            [CustomizationFormProperties.BACKGROUND_TYPE]:
              BackgroundType.Gradient,
            [CustomizationFormProperties.BACKGROUND_GRADIENT_COLORS]: [
              colors[1].hexValue,
              colors[2].hexValue,
            ],
            [CustomizationFormProperties.TEXT]: colors[0].hexValue,
            [CustomizationFormProperties.BUTTONS_BACKGROUND_COLOR]: '',
            [CustomizationFormProperties.BUTTONS_BORDER_COLOR]:
              colors[0].hexValue,
            [CustomizationFormProperties.BUTTONS_TEXT_COLOR]:
              colors[0].hexValue,
            themeName: 'custom_colors_gradient_3',
          },
        ]
      : []

  return [...customColorsThemes, ...STATIC_GRADIENT_THEMES]
}
